import common from "../common";

export default class Text extends PIXI.Container {
    constructor(copy, style)
    {
        super();

        this.copy = copy;
        this.style = style;
        this.textItem = null;
        this.webText = false;

        this.init();
    }

    init()
    {
        if(common.country == 'ar' && isNaN(Number(this.copy)))
        {
            this.webText = true;

            var spl = this.style.font.split(" ");
            this.style.font = spl[0] + ' fred';

            spl.splice(0, 1);

            var oldFont = spl.join(" ");
            if(oldFont.indexOf('Lalezar') > -1)
            {
                this.style.fillGradientType = PIXI.TEXT_GRADIENT.LINEAR_VERTICAL;
                this.style.fill = [0xfeef42, 0xfac113];
                this.style.fillGradientStops = [0, 1];
                this.style.strokeThickness = 4;
                this.style.dropShadow = true;
                this.style.dropShadowAngle = 90*PIXI.DEG_TO_RAD;
                this.style.dropShadowAlpha = 0.5;
                this.style.dropShadowDistance = 3.5;

                if(oldFont == 'Lalezar48')
                {
                    this.style.stroke = 0xf25a1e;
                    this.style.dropShadowColor = 0x045a89;
                }
                else if(oldFont == 'Lalezar56')
                {
                    this.style.stroke = 0x102e42;
                    this.style.dropShadowColor = 0xf94856;
                }
            }
            else if(oldFont == 'Pangolin')
            {
                this.style.color = 0x3a3a3a;
            }

            this.checkArabicPunctuation();
            
            this.textItem = new PIXI.Text(this.copy, this.style);
        }
        else
        {
            this.textItem = new PIXI.extras.BitmapText(this.copy, this.style);
        }

        this.addChild(this.textItem);
    }

    checkArabicPunctuation()
    {
        var frontPunc = '';
        for(var i = this.copy.length - 1; i >= 0; i--)
        {
            console.log('char:', this.copy.charAt(i));
            if(this.copy.charAt(i).search(/[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/g) > -1)
            {
                frontPunc += this.copy.charAt(i);
                this.copy = this.copy.substr(0, i);
                console.log(frontPunc);
                console.log(this.copy);
                console.log(frontPunc + this.copy);
            }
            else
            {
                break;
            }
        }
        this.copy = frontPunc + this.copy;
    }

    set text(copy)
    {
        this.copy = copy;
        if(common.country == 'ar' && isNaN(Number(this.copy)))
        {
            this.checkArabicPunctuation();
        }
        this.textItem.text = this.copy;
    }

    set anchor(value)
    {
        this.textItem.anchor = value;
        return this.textItem.anchor;
    }

    get anchor()
    {
        return this.textItem.anchor;
    }
}